import Component from '../../shared/component';

export default class Popover extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$popover = this.$element.find('.popover-wrapper');
    this.$trigger = this.$element.find('.popover-trigger');
    this.$arrowTop = this.$element.find('.popover-content-arrow--top');
    this.$arrowRight = this.$element.find('.popover-content-arrow--right');

    this.setPosition('bottom');

    this.bindEvents();
  }

  bindEvents() {
    this.handleTriggerHover = this.handleTriggerHover.bind(this);

    this.$element.on('mouseover.Popover', this.handleTriggerHover);
  }

  unbindEvents() {
    this.$element.off('mouseover.Popover', this.handleTriggerHover);
  }

  setPosition(position) {
    if (position === 'bottom') {
      this.$arrowTop.show();
      this.$arrowRight.hide();

      this.positionBottom();
    }

    if (position === 'left') {
      this.$arrowTop.hide();
      this.$arrowRight.show();

      this.positionLeft();
    }
  }

  handleTriggerHover() {
    if (
      this.checkPageFormat(window.pageContentWidthSm) &&
      this.contentSmPosition()
    ) {
      this.setPosition(this.contentSmPosition());
    } else {
      this.setPosition('bottom');

      if (!this.isElementInViewport(this.$popover)) {
        this.setPosition('left');
      }
    }
  }

  positionBottom() {
    this.$popover.css({
      top: this.$element.outerHeight() + this.extraTop(),
      right:
        this.$element.outerWidth() / 2 -
        this.$arrowTop.outerWidth() +
        this.extraRight(),
    });
  }

  positionLeft() {
    this.$popover.css({
      top:
        this.$element.outerHeight() / 2 -
        this.$popover.outerHeight() / 2 -
        this.$arrowRight.outerHeight() / 2 +
        this.extraTop(),
      right:
        this.$element.outerWidth() +
        this.$arrowRight.outerWidth() +
        this.extraRight() -
        this.$trigger.position().left,
    });

    this.$arrowRight.css({
      top: this.$popover.outerHeight() / 2 + this.$element.outerHeight() / 2,
    });
  }

  extraTop() {
    if (this.$trigger.data('popover-extra-top')) {
      return this.$trigger.data('popover-extra-top');
    } else {
      return 0;
    }
  }

  extraRight() {
    // For triggers that are full width instead of fix width
    // on mobile, we need a way to align them in center of viewport
    // under certain circumstances
    if (
      this.$trigger.data('popover-content-sm-extra-right') &&
      this.checkPageFormat(window.pageContentWidthSm)
    ) {
      return this.$trigger.data('popover-content-sm-extra-right');
    } else if (this.$trigger.data('popover-extra-right')) {
      return this.$trigger.data('popover-extra-right');
    } else {
      return 0;
    }
  }

  contentSmPosition() {
    return this.$trigger.data('popover-content-sm-position');
  }

  isElementInViewport(element) {
    const rect = element[0].getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= window.$window.height() &&
      rect.right <= window.$window.width()
    );
  }

  checkPageFormat(format) {
    return window.$window.width() <= format;
  }
}
